// Job descriptions longer than this are cut (the server applies the same limit).
export const MAX_JOB_DESCRIPTION_WORDS = 1000;

export const countWords = (text: string) => text.match(/\S+/g)?.length ?? 0;

// Keeps the first maxWords words of text, with the original spacing and line breaks.
export function limitWords(text: string, maxWords: number) {
  const words = [...text.matchAll(/\S+/g)];
  if (words.length <= maxWords) return text;
  const last = words[maxWords - 1];
  return text.slice(0, (last.index ?? 0) + last[0].length);
}

// Long dashes make text read as AI-written. In ranges ("2021 – 2023",
// "10–15") they become a hyphen; in sentences, a comma.
const DATE_END =
  /(?=\d|(?:jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec|present|current|now|today)\b|(?:january|february|march|april|june|july|august|september|october|november|december)\b)/i;
const DATE_RANGE = new RegExp(`(\\d)\\s*[–—]\\s*${DATE_END.source}`, "gi");

export const plainDashes = (text: string) =>
  text
    .replace(/(\d)[–—](\d)/g, "$1-$2")
    .replace(DATE_RANGE, "$1 - ")
    .replace(/\s*[—–]\s*/g, ", ")
    .replace(/,\s*,/g, ",");

// Applies plainDashes to every string in AI output, except under keys that
// hold the candidate's own wording (original*), which stays as written.
export function withPlainDashes<T>(value: T): T {
  if (typeof value === "string") return plainDashes(value) as T;
  if (Array.isArray(value)) return value.map(withPlainDashes) as T;
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, v]) => [key, key.startsWith("original") ? v : withPlainDashes(v)])
    ) as T;
  }
  return value;
}
